// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"FO","productsContainer":"GO","searchVerticalReco":"HO","heading":"IO"};